/*
Monotype Foundry Platform API
Version 1.0.0

Definition: BundleMode

Properties:
  mode: string
*/

var BundleMode = (function () {
  function validateBundleMode (arg) {
    // Validate mode
    if (arg.mode && !(typeof arg.mode === 'string')) {
      throw new Error('BundleMode.mode: Wrong type: Got \'' + (typeof arg.mode) + '\', but expected: \'string\'')
    }
  }
  function buildBundleMode (arg) {
    var BundleMode = arg
    // Complete mode
    // Expected Type: string
    BundleMode.mode = BundleMode.mode || ''
    return BundleMode
  }
  return {
    validate: validateBundleMode,
    build: buildBundleMode
  }
})()

module.exports = BundleMode
